import { z } from 'zod';

import { TestAttemptAnswersSchema } from '../test-attempt/test-attempt';

/**
 * Saving progress without finishing — what the client calls as the member moves
 * between questions, so a dropped connection or a killed app does not cost the
 * attempt.
 *
 * The whole answer set each time rather than a delta: a delta needs an ordering
 * guarantee the network does not give, and two out-of-order patches would leave
 * an answer set neither the member nor the server chose.
 */
export const TestAttemptSaveSchema = z.object({ answers: TestAttemptAnswersSchema }).strict();

export type TestAttemptSaveRequest = z.infer<typeof TestAttemptSaveSchema>;

/**
 * Submitting for scoring.
 *
 * Carries the answers too, rather than scoring whatever was last saved: the
 * member's final "submit" must score what is on their screen, and relying on a
 * prior save would lose the last question whenever the save had not landed yet.
 */
export const TestAttemptSubmitSchema = z.object({ answers: TestAttemptAnswersSchema }).strict();

export type TestAttemptSubmitRequest = z.infer<typeof TestAttemptSubmitSchema>;
